var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpenRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lock_open_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21196_61550",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21196_61550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock_open_right_2",
    d: "M12.0681 45.967H38.2485V24.3911H12.0681V45.967ZM12.0681 50C10.9493 50 9.99161 49.6051 9.19496 48.8154C8.39832 48.0256 8 47.0762 8 45.967V24.3911C8 23.2742 8.39832 22.318 9.19496 21.5224C9.99161 20.7269 10.9493 20.3291 12.0681 20.3291H27.0696V16.0753C27.0696 13.2773 28.0511 10.8986 30.0142 8.93893C31.9772 6.97964 34.364 6 37.1747 6C39.5783 6 41.6769 6.73104 43.4705 8.19313C45.2644 9.65555 46.415 11.4876 46.9224 13.6892C47.0877 14.2692 46.9889 14.8119 46.6261 15.3172C46.2628 15.8226 45.7888 16.0753 45.2041 16.0753C44.6129 16.0753 44.1281 15.9446 43.7498 15.6833C43.3719 15.4223 43.0906 15.0231 42.9061 14.4859C42.5785 13.2271 41.8864 12.175 40.8299 11.3296C39.7735 10.4842 38.5538 10.0615 37.1711 10.0615C35.4737 10.0615 34.0487 10.641 32.896 11.8C31.743 12.959 31.1665 14.3863 31.1665 16.0819V20.3291H38.2485C39.3751 20.3291 40.3397 20.7269 41.1422 21.5224C41.9446 22.318 42.3459 23.2742 42.3459 24.3911V45.967C42.3459 47.0762 41.9446 48.0256 41.1422 48.8154C40.3397 49.6051 39.3751 50 38.2485 50H12.0681Z",
    fill: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lock_open_right_3",
    d: "M28.179 38.3159C27.304 39.1726 26.2476 39.601 25.0098 39.601C23.7719 39.601 22.7122 39.1732 21.8306 38.3177C20.949 37.4621 20.5082 36.4413 20.5082 35.2552C20.5082 34.0691 20.9457 32.9996 21.8207 32.0468C22.6957 31.0941 23.7521 30.6177 24.9899 30.6177C26.2278 30.6177 27.2875 31.0941 28.1691 32.0468C29.0507 32.9996 29.4915 34.0593 29.4915 35.226C29.4915 36.4292 29.054 37.4592 28.179 38.3159Z",
    fill: "#FFD25E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenRight);
export default __webpack_public_path__ + "static/media/lockOpenRight.bb78a0df47d660efe44c0c84d21f8cd3.svg";
export { ForwardRef as ReactComponent };